import { Box, Card, Typography } from "@mui/material";

const PaymentCard = ({ item }) => {
  const { pendingAmount, numberOfTickets } = item;
  return (
    <Box>
      <Card sx={{ p: 3 }}>
        <Box display="flex" flexDirection="row">
          <Typography>Number of tickets : &nbsp;</Typography>
          <Typography> {numberOfTickets || 0}</Typography>
        </Box>
        <Box display="flex" flexDirection="row">
          <Typography>Amount Pending : &nbsp;</Typography>
          <Typography> {pendingAmount || 0}</Typography>
        </Box>
      </Card>
    </Box>
  );
};

export default PaymentCard;
